import firebase from './index'

export function firebaseFetchAllUsers() {
  return new Promise((resolve, reject) => {
    firebase
      .database()
      .ref()
      .child('users')
      .once('value')
      .then(snap => {
        resolve(snap.val())
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function firebaseFetchAllUsersInDealer(dealerID) {
  return new Promise((resolve, reject) => {
    firebase
      .database()
      .ref()
      .child('users')
      .orderByChild('dealer')
      .equalTo(dealerID)
      .once('value')
      .then(snap => {
        resolve(snap.val())
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function firebaseFetchAllUsersInFactory(factoryID) {
  return new Promise((resolve, reject) => {
    firebase
      .database()
      .ref()
      .child('users')
      .orderByChild('factory')
      .equalTo(factoryID)
      .once('value')
      .then(snap => {
        resolve(snap.val())
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function firebaseFetchUserProfile(userID) {
  return new Promise((resolve, reject) => {
    firebase
      .database()
      .ref()
      .child('users')
      .child(userID)
      .once('value')
      .then(snap => {
        resolve(snap.val())
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function firebaseCreateUserProfile(uid, newProfile) {
  return firebase
    .database()
    .ref()
    .child(`users`)
    .child(uid)
    .set(newProfile)
}

export function firebaseUpdateUserProfile(uid, newProfile) {
  return firebase
    .database()
    .ref()
    .child(`users`)
    .child(uid)
    .update(newProfile)
}

export function firebaseUpdateUserNotification(uid, notification) {
  return firebase
    .database()
    .ref()
    .child(`users`)
    .child(uid)
    .child('notification')
    .update(notification)
}
